export const CHANGE_USER_STATUS_REQUEST = " CHANGE_USER_STATUS_REQUEST";
export const CHANGE_USER_STATUS_SUCCESS = " CHANGE_USER_STATUS_SUCCESS";
export const CHANGE_USER_STATUS_FAILURE = " CHANGE_USER_STATUS_FAILURE";
